import {Backend} from '@common/backend'
import {globals} from '@extensions/globals-base'

type RetType = {
  query?: string
  data?: any
  totalPages?: string
  total?: string
}

export const fetchUnsplash = async (
  query: string,
  page: number,
  color: string
): Promise<RetType> => {
  const companyId = globals.getCompanyId()

  const resp = await Backend.postJSON<RetType>('/data/unsplash/proxy', {
    ...Backend.loadCred(),
    companyId,
    query,
    page: String(page),
    color
  })

  return resp
}
